"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));

var _reactOverlays = require("react-overlays");

var _parse = _interopRequireDefault(require("date-fns/parse"));

require("./style.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const elementId = 'cccisd-datepicker'; // Add div to the body where we will render the calendar

if (!document.getElementById(elementId)) {
  const div = document.createElement('div');
  div.setAttribute('id', elementId);
  document.body.appendChild(div);
}

const CalendarContainer = (_ref) => {
  let children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_reactOverlays.Portal, {
    container: document.getElementById(elementId)
  }, children);
};
/** Show an input field and a calendar which helps to pick the date */


class Component extends _react.default.Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "getSelected", () => {
      const selected = this.props.selected;
      const filler = '0000-00-01 12:00:00';

      if (!selected) {
        return null;
      }

      if (typeof selected === 'string') {
        return (0, _parse.default)(selected + filler.substring(selected.length), 'yyyy-MM-dd HH:mm:ss', new Date());
      }

      return selected;
    });
  }

  render() {
    const _this$props = this.props,
          dateFormat = _this$props.dateFormat,
          placeholderText = _this$props.placeholderText,
          useDateFormatAsPlaceholder = _this$props.useDateFormatAsPlaceholder;
    let placeholder = placeholderText;

    if (!placeholder && useDateFormatAsPlaceholder && typeof dateFormat === 'string') {
      placeholder = dateFormat;
    }

    return /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, _extends({}, this.props, {
      selected: this.getSelected(),
      placeholderText: placeholder,
      popperContainer: CalendarContainer
    }));
  }

}

exports.default = Component;

_defineProperty(Component, "propTypes", {
  /** Class name for the input field */
  className: _propTypes.default.string,

  /** Date format */
  dateFormat: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),

  /** Callback when date is selected */
  onChange: _propTypes.default.func,

  /** Placeholder text */
  placeholderText: _propTypes.default.string,

  /** Selected value. It has to be Date object */
  selected: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),

  /** Should we use the date format as the placeholder (in the absence of specified placeholderText)? NOTE: this is only used if date format is a string. */
  useDateFormatAsPlaceholder: _propTypes.default.bool
});

_defineProperty(Component, "defaultProps", {
  className: 'form-control',
  dateFormat: 'MM/dd/yyyy'
});